import request from '@/utils/request'

const http = request()

export const listMeetings = params => http.post('/project/meetinginfo/list', params)

export const saveMeeting = params => (params.nextStep ? http.raw('/project/meetinginfo/submit', params) : http.raw('/project/meetinginfo/save', params))

export const saveMeetingMinutes = params => http.post('/project/meetinginfo/minutes', params)

export const updateMeeting = params => http.raw('/project/meetinginfo/update', params)

export const delMeeting = meetingId => http.post('/project/meetinginfo/delete', { meetingId })

export const closeMeeting = (meetingId, projectId) => http.post('/project/meetinginfo/close', { meetingId, projectId })

export const getMeeting = meetingId => http.post('/project/meetinginfo/get', { meetingId })

export const getVoteResult = meetingId => http.post('/project/meetinginfo/getVoteResult', { meetingId })

export const listExternalMembers = userName => http.post('/project/meetinginfo/listexternalmembers', { userName })

export const saveExternalMembers = params => http.post('/project/meetinginfo/saveexternalmembers', params)

export const sendMeetingSms = (meetingId, projectId) => http.post('/project/meetinginfo/sms', { meetingId, projectId })
